import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { get } from 'rf-lib';

const LinkButton = styled(Link)`
  color: white;
  text-decoration: none;
  border: none;
  padding: 1rem 1rem;
  margin: 2px;
  border-radius: 6px;
  font-weight: 400;
  font-size: 1em;
  cursor: pointer;
  text-align: center;
  background: ${get('colorButton')};
`;

export default LinkButton;
